import {isNumber, isBoolean, isString, isArray} from '../scripts/types'

const Number = {
  toModel(str) {
    return parseFloat(str)
  },
  toString(arr) {
    if (!arr) return NaN
    return arr.toString()
  }
}
const Boolean = {
  toModel(str) {
    return str !== '0' && str !== 'false'
  },
  toString(arr) {
    if (!arr) return 'false'
    return arr.toString()
  }
}
const Array = {
  toModel(str) {
    return str.split(',')
  },
  toString(arr) {
    if (arr) return arr.join(',')
    return ''
  }
}

export default {
  data() {
    return {
      queryConverter: {},
      query: {},
      loading: false
    }
  },
  watch: {
    '$route': '_handleRouteChange'
  },
  mounted() {
    this.$nextTick(() => {
      let conv = this.queryConverter
      Object.entries(this.query).forEach(([key, value]) => {
        if (!isString(value) && !conv.hasOwnProperty(key)) {
          if (isNumber(value)) conv[key] = Number
          else if (isBoolean(value)) conv[key] = Boolean
          else if (isArray(value)) conv[key] = Array
        }
        if (isNumber(value) && isNaN(value)) this.query[key] = ''
      })
      this._handleRouteChange()
    })
    this.listenDomEvent(true)
  },
  beforeDestroy() {
    this.listenDomEvent(false)
  },
  methods: {
    _handleRouteChange() {
      let query = {}, conv = this.queryConverter
      Object.entries(this.$route.query).forEach(([key, value]) => {
        if (conv.hasOwnProperty(key)) value = conv[key].toModel(value)
        query[key] = value
      })
      this.query = Object.assign(this.query, query)
      if (this.handleRouteChange) this.handleRouteChange(this.query, this.$route.params)
    },
    relocate() {
      let query = {}, conv = this.queryConverter
      Object.entries(this.query).forEach(([key, value]) => {
        if (conv.hasOwnProperty(key)) value = conv[key].toString(value)
        if ((value || value === 0) && value !== '') query[key] = value
      })
      this.$router.push({path: this.$route.path, query}).then(route => {
        if (!route.path && !route.query) this._handleRouteChange()
      })
    }
  }
}
